import type { MDXComponents } from 'mdx/types.js'
import { ArticleCTA } from '@/content/blog/_components/ArticleCTA'
import { MathBlock } from '@/content/blog/_components/MathBlock'
import { HSAReimbursementCalculator, HSAOpportunityCostCalculator } from '@/content/blog/_components/PlaceholderCalculators'

export const mdxComponents: MDXComponents = {
  // HTML element overrides — apply brand styles within prose context
  h1: (props: React.ComponentPropsWithoutRef<'h1'>) => <h1 className="text-3xl font-bold text-[#1B365D] mt-10 mb-4" {...props} />,
  h2: (props: React.ComponentPropsWithoutRef<'h2'>) => <h2 className="text-2xl font-bold text-[#1B365D] mt-8 mb-3" {...props} />,
  h3: (props: React.ComponentPropsWithoutRef<'h3'>) => <h3 className="text-xl font-semibold text-[#1B365D] mt-6 mb-2" {...props} />,
  a: (props: React.ComponentPropsWithoutRef<'a'>) => <a className="text-[#1B365D] underline hover:text-[#486581] transition" {...props} />,
  // Custom components available in any MDX file without import
  ArticleCTA,
  MathBlock,
  HSAReimbursementCalculator,
  HSAOpportunityCostCalculator,
}
